//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { RightsRequestMessageSource } from '@apis/rights-management/rightsManagementApiModels';
import { IRightsOption } from '@legacy-components/rights-management/request-rights-model';
import { RequestTextSource } from '@uia/rights/forms/RequestText';
import { jaccardSimilarity } from '@utils/jaccardSimilarity';

// 0.6 was chosen as a threshold based on some trial and error. The goal is to make sure any significant change is classified as 'Custom'.
const JACCARD_SIMILARITY_THRESHOLD = 0.6;

export const getRequestMetadata = (
  requestMessage: string,
  requestTextIndex: number,
  requestTextSource: RequestTextSource,
  aiGeneratedMessage?: string,
  selectedRightsOption?: IRightsOption,
) => {
  const requestMessageSource = (() => {
    switch (requestTextSource) {
      case RequestTextSource.AI:
        return RightsRequestMessageSource.AiGenerated;
      case RequestTextSource.CONFIG:
        return RightsRequestMessageSource.ConfiguredMessage;
      case RequestTextSource.CUSTOM:
        if (requestMessage && aiGeneratedMessage) {
          const similarityWithAiGenMessage = jaccardSimilarity(
            requestMessage,
            aiGeneratedMessage,
          );
          if (similarityWithAiGenMessage > JACCARD_SIMILARITY_THRESHOLD) {
            return RightsRequestMessageSource.AiAssisted;
          }
          return RightsRequestMessageSource.Custom;
        }
        return RightsRequestMessageSource.Custom;
      default:
        return RightsRequestMessageSource.Custom;
    }
  })();

  const requestMessageLanguage =
    requestTextSource === RequestTextSource.CONFIG
      ? selectedRightsOption?.rightsRequestData.data[requestTextIndex]
          ?.languageCode
      : undefined;

  return {
    requestMessageSource,
    requestMessageLanguage,
  };
};
